<template>
  <ux-form
    ref="form"
    :data="formData"
    width="550px"
    :colon="true"
    :rules="rules"
    label-width="56px"
    data-automation="addDevice"
  >
    <ux-form-item :label="$t('HT.addDevice.type')" prop="type">
      <ux-input
        v-model="formData.type"
        :maxlength="50"
        :placeholder="$t('HT.rules.addDevice.type')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addDevice.manufacturer')" prop="manufacturer">
      <ux-input
        v-model="formData.manufacturer"
        :maxlength="50"
        :placeholder="$t('HT.rules.addDevice.manufacturer')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item
      :label="$t('HT.apiStepTwo.protocol')"
      prop="protocol.protocol_name"
      :rules="rules.protocol"
    >
      <ux-input
        v-model="formData.protocol.protocol_name"
        :maxlength="50"
        :placeholder="$t('HT.rules.addDevice.protocol')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item
      :label="$t('HT.debug3.domain')"
      v-for="(item, index) in formData.domains"
      :key="index"
      :prop="'domains.' + index"
      :rules="rules.domains"
    >
      <ux-input
        class="x-flex-one"
        v-model="formData.domains[index]"
        :placeholder="$t('HT.domain.placeholder')"
      ></ux-input>
      <ux-button class="add-button" v-if="index == 0" type="primary" @click="addDomains"
        >+</ux-button
      >
      <ux-button class="add-button" v-else type="primary" @click="delDomains(index)">-</ux-button>
    </ux-form-item>
    <ux-form-item :label="$t('HT.remark')" start prop="remark">
      <ux-input
        v-model="formData.remark"
        type="textarea"
        :autosize="{ minRows: 5, maxRows: 5 }"
        resize="none"
        :maxlength="180"
        show-word-limit
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          domains: '',
          manufacturer: '',
          online: '',
          remark: '',
          type: '',
          protocol: {
            protocol_name: ''
          }
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.addDevice()
    };
  },
  created() {
    this.formData.domains = this.formData.domains.split(';');
  },

  methods: {
    /**
     * 添加域名
     */
    addDomains() {
      this.formData.domains.push('');
    },

    /**
     * 删除域名
     */
    delDomains(index) {
      this.formData.domains.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.add-button {
  box-sizing: border-box;
  width: 40px;
  min-width: auto;
  margin-left: 10px;
}
</style>
